import React, { useState } from "react";
import { useUrlFriendlyToParameters } from 'helpers/urlFriendly';
import { useGetNocs } from 'helpers/commonCodes';
import { usePathFlag } from "helpers/utils";

function PageHeaderFlag({ title, pageTitle }) {
  const [showImage, setShowImage] = useState(true);
  let params = useUrlFriendlyToParameters()
  const data = useGetNocs(params)
  const nocItem = data?.nocs?.find(n => n.code === params.mirs_noc)

  const hideImg = () => {
    setShowImage(false);
  };


  let image = nocItem?.code;
  let nocDescription = nocItem?.description;
  let nocLongDescription = nocItem?.longDescription;
  const codeNoc = usePathFlag(image);
  return (
    <div>
      {title}
      {" "}
      <>
        {`${nocDescription} ${pageTitle ? "-" : ""}`}
        &nbsp;
        {(pageTitle ? pageTitle : "")}
      </>
    </div>
  );
};

export default PageHeaderFlag;
